// ===== Interfaces =====

import { ITwitterData } from '../interfaces';

// ===== Constants =====

const TWITTER_URL_REGEX = /^https?:\/\/(?:www\.)?(?:twitter|x)\.com\/([^/?#]+)(?:\/status\/(\d+))?/i;

const getTwitterId = (url = ''): ITwitterData | boolean => {
    const match = url ? url.match(TWITTER_URL_REGEX) : null;
    if (!match) return false;

    // match[1] = username
    // match[2] = tweet ID
    const username = match[1] ?? null;
    const id = match[2] ?? null;

    if (username || id) {
        return { username, id };
    }

    return false;
};

export default getTwitterId;
